var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useForm } from "react-hook-form";
import api from "@/api/admin/admin";
import useAdminStore from "@/services/store/useAdminStore";
import { k } from "@/utilities/i18n";
import translate from "@/utilities/i18n/getTranslate";
import errorHandler from "@/utilities/errorHandler";
var requiredField = ["name", "email", "password"];
var usePartnerUser = function () {
    var adminNotification = useAdminStore().adminNotification;
    var financeUser = useForm({
        mode: "onChange",
    });
    var salesUser = useForm({
        mode: "onChange",
    });
    var dialogSalesUser = useForm({
        mode: "onChange",
    });
    var operationUser = useForm({
        mode: "onChange",
    });
    var addPartnerUsers = function (partnerId) { return __awaiter(void 0, void 0, void 0, function () {
        var users, allForm, _a, err_1, _b, err_2, _c, err_3, _d, err_4;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    users = {
                        finance: null,
                        sales: null,
                        dialogSales: null,
                        operation: null,
                    };
                    allForm = [financeUser, salesUser, dialogSalesUser, operationUser];
                    allForm.forEach(function (form) {
                        var _a = form.formState.touchedFields, name = _a.name, email = _a.email, password = _a.password;
                        if (name || email || password) {
                            form.trigger(requiredField);
                        }
                    });
                    if (!financeUser.formState.isValid) return [3 /*break*/, 4];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    _a = users;
                    return [4 /*yield*/, api.partners.partnerUser.post({ partnerId: partnerId }, financeUser.getValues())];
                case 2:
                    _a.finance = _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _e.sent();
                    addErrorNotification(err_1, "finance");
                    return [3 /*break*/, 4];
                case 4:
                    if (!salesUser.formState.isValid) return [3 /*break*/, 8];
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, 7, , 8]);
                    _b = users;
                    return [4 /*yield*/, api.partners.partnerUser.post({ partnerId: partnerId }, salesUser.getValues())];
                case 6:
                    _b.sales = _e.sent();
                    return [3 /*break*/, 8];
                case 7:
                    err_2 = _e.sent();
                    addErrorNotification(err_2, "sales");
                    return [3 /*break*/, 8];
                case 8:
                    if (!dialogSalesUser.formState.isValid) return [3 /*break*/, 12];
                    _e.label = 9;
                case 9:
                    _e.trys.push([9, 11, , 12]);
                    _c = users;
                    return [4 /*yield*/, api.partners.partnerUser.post({ partnerId: partnerId }, dialogSalesUser.getValues())];
                case 10:
                    _c.dialogSales = _e.sent();
                    return [3 /*break*/, 12];
                case 11:
                    err_3 = _e.sent();
                    addErrorNotification(err_3, "Dialog sales");
                    return [3 /*break*/, 12];
                case 12:
                    if (!operationUser.formState.isValid) return [3 /*break*/, 16];
                    _e.label = 13;
                case 13:
                    _e.trys.push([13, 15, , 16]);
                    _d = users;
                    return [4 /*yield*/, api.partners.partnerUser.post({ partnerId: partnerId }, operationUser.getValues())];
                case 14:
                    _d.operation = _e.sent();
                    return [3 /*break*/, 16];
                case 15:
                    err_4 = _e.sent();
                    addErrorNotification(err_4, "operation");
                    return [3 /*break*/, 16];
                case 16: return [2 /*return*/, users];
            }
        });
    }); };
    var addErrorNotification = function (err, userType) {
        adminNotification.add({
            type: adminNotification.types.ERROR,
            message: "".concat(userType, " user - ").concat(errorHandler(err, translate(k.ERR_addingPartnerUserError))),
        });
    };
    return {
        financeUser: financeUser,
        salesUser: salesUser,
        dialogSalesUser: dialogSalesUser,
        operationUser: operationUser,
        addPartnerUsers: addPartnerUsers,
    };
};
export default usePartnerUser;
//# sourceMappingURL=data:application/json;base64,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